import { OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from "../../login/services/auth.service";
import { DacConfig } from 'app/shared/services/dac-config.service';
var AssessmentsComponent = /** @class */ (function () {
    function AssessmentsComponent(authService, router, dacConfig) {
        this.authService = authService;
        this.router = router;
        this.dacConfig = dacConfig;
    }
    AssessmentsComponent.prototype.ngOnInit = function () {
    };
    AssessmentsComponent.prototype.shouldShowHeader = function () {
        return !this.dacConfig.seamlessMode;
    };
    Object.defineProperty(AssessmentsComponent.prototype, "notSeamless", {
        get: function () {
            return !this.dacConfig.seamlessMode;
        },
        enumerable: true,
        configurable: true
    });
    return AssessmentsComponent;
}());
export { AssessmentsComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/assessments/assessments.component.ts.pre-build-optimizer.js